(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

document.addEventListener('DOMContentLoaded', function (e) {
  var showAuthBtn = document.getElementById('katisoft-show-auth-form'),
      authContainer = document.getElementById('katisoft-auth-container'),
      close = document.getElementById('katisoft-auth-close'),
      authForm = document.getElementById('katisoft-auth-form'),
      status = authForm.querySelector('[data-message="status"]');
  showAuthBtn.addEventListener('click', function () {
    authContainer.classList.add('show');
    showAuthBtn.parentElement.classList.add('hide');
  });
  close.addEventListener('click', function () {
    authContainer.classList.remove('show');
    showAuthBtn.parentElement.classList.remove('hide');
  });
  authForm.addEventListener('submit', function (e) {
    e.preventDefault();
    resetMessages();
    var data = {
      name: authForm.querySelector('[name="username"]').value,
      password: authForm.querySelector('[name="password"]').value,
      nonce: authForm.querySelector('[name="katisoft_auth"]').value
    };

    if (!data.name || !data.password) {
      status.innerHTML = "Missing Data";
      status.classList.add('error');
      return;
    }

    var url = authForm.dataset.url;
    var params = new URLSearchParams(new FormData(authForm));
    authForm.querySelector('[name="submit"]').value = "Logging in...";
    authForm.querySelector('[name="submit"]').disabled = true;
    fetch(url, {
      method: "POST",
      body: params
    }).then(function (res) {
      return res.json();
    })["catch"](function (error) {
      resetMessages();
    }).then(function (response) {
      resetMessages();

      if (response === 0 || !response.status) {
        status.innerHTML = response.message;
        status.classList.add('error');
        return;
      }

      status.innerHTML = response.message;
      status.classList.add('success');
      authForm.reset();
      window.location.reload();
    });
  });

  function resetMessages() {
    status.innerHTML = '';
    status.classList.remove('success', 'error');
    authForm.querySelector('[name="submit"]').value = "Login";
    authForm.querySelector('[name="submit"]').disabled = false;
  }
});

},{}]},{},[1]);
